module.exports = __webpack_public_path__ + "img/banner-data.10cba2e6.png";